<template>
  <div class="d-flex align-center">
    <c-feature-icon checked :icon="icon" class="mr-1"/>
    <span v-text="caption"/>
  </div>
</template>

<script>
import CFeatureIcon from '../CFeatureIcon'

export default {
  name: 'CItem',
  components: {
    CFeatureIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    caption: {
      type: String,
      required: true
    }
  }
}
</script>
